export default __webpack_public_path__ + "static/media/TrendUp.ef556103.svg";